import { render, staticRenderFns } from "./SoftFairFahrerkreis.vue?vue&type=template&id=6e64b058&"
import script from "./SoftFairFahrerkreis.vue?vue&type=script&lang=js&"
export * from "./SoftFairFahrerkreis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports